export default __webpack_public_path__ + "static/media/noMessages.d0731892.png";